var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('list-item-with-icon');
import { breakpoints, theme } from '@shapeable/theme';
import { Icon } from './icon';
export var ListItemWithIconDefaultProps = {
  iconSize: 24,
  iconColor: 'secondary',
  spaceUnits: 3,
  iconStyle: {}
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    align-items: flex-start;\n    list-style: none !important;\n    margin-left: -1.5em;\n\n    &::before {\n      content: none !important;\n      padding-left: 0;\n    }\n  "], ["\n    display: flex;\n    align-items: flex-start;\n    list-style: none !important;\n    margin-left: -1.5em;\n\n    &::before {\n      content: none !important;\n      padding-left: 0;\n    }\n  "])))
});
var IconStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var spaceUnits = _a.spaceUnits;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      margin-right: ", ";\n    "], ["\n      margin-right: ", ";\n    "])), theme.UNIT(spaceUnits));
  })
});
// -------- Components -------->
var My = {
  Container: styled.li(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Icon: styled(Icon)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), IconStyles)
};
export var ListItemWithIcon = function (props) {
  var className = props.className,
    children = props.children,
    iconSize = props.iconSize,
    iconColor = props.iconColor,
    spaceUnits = props.spaceUnits,
    iconStyle = props.iconStyle,
    rest = __rest(props, ["className", "children", "iconSize", "iconColor", "spaceUnits", "iconStyle"]);
  var Icon = props.icon;
  return React.createElement(My.Container, __assign({}, rest, {
    className: cls.name(className)
  }), Icon && React.createElement(My.Icon, {
    color: iconColor,
    style: iconStyle,
    spaceUnits: spaceUnits,
    size: iconSize
  }, React.createElement(Icon, null)), children);
};
ListItemWithIcon.defaultProps = ListItemWithIconDefaultProps;
ListItemWithIcon.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;